// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"9aad7c31","60":"47a1b30b","215":"bbd5cfa2","359":"b72a0ed1","415":"6e1095f6","434":"497ff71a","487":"364226fe","495":"73d99e67","529":"3542d103","631":"935b5183","639":"2a73351a","719":"9f5c5b6e","754":"f626cccf","766":"25648399","973":"233d805c"}[chunkId] + ".chunk.js";
};